var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// Models
import { ISchemaType, } from '../../models/dataSchema/dataSchemaTypes';
// Form
import * as yup from 'yup';
// Translate
import i18n from '../../config/i18next';
yup.setLocale({
    array: {
        max: function (_a) {
            var path = _a.path, max = _a.max;
            return "Le champs " + i18n.t(path) + " doit avoir au maximum " + max + " choix s\u00E9lectionn\u00E9s";
        },
        min: function (_a) {
            var path = _a.path, min = _a.min;
            return "Le champs " + i18n.t(path) + " doit avoir au moins " + min + " choix s\u00E9lectionn\u00E9s";
        },
    },
    date: {
        max: i18n.t('dateMax'),
    },
    mixed: {
        notType: function notType(ref) {
            var path = ref.path, type = ref.type;
            return i18n.t(path) + " doit \u00EAtre " + i18n.t(type) + " valide";
        },
        required: function required(ref) {
            var path = ref.path;
            return "Le champ " + i18n.t(path) + " est requis";
        },
    },
});
/**
 * Build form properties
 * @param iuiSchema
 * @param dataSchema
 * @param values
 */
export var buildFormProps = function (iuiSchema, dataSchema, values) {
    return {
        childrenProps: iuiSchema.groups.map(function (uiGroup) { return buildGroupProps(uiGroup, dataSchema, values); }),
        description: iuiSchema.description || dataSchema.description,
        title: iuiSchema.title || dataSchema.title,
    };
};
/**
 * Build Group properties
 * @param properties
 * @param conditions
 * @param createTitle
 * @param title
 * @param dataSchema
 * @param values
 */
var buildGroupProps = function (_a, dataSchema, values) {
    var properties = _a.properties, conditions = _a.conditions, createTitle = _a.createTitle, title = _a.title;
    var childrenProps = buildFieldList(dataSchema, properties, conditions, values);
    var linkedFieldList = conditions ? getLinkedFieldList(conditions) : {};
    return { createTitle: createTitle, title: title, childrenProps: childrenProps, linkedFieldList: linkedFieldList };
};
/**
 * Build field list
 * @param dataSchema
 * @param fieldsProperties
 * @param fieldsConditions
 * @param values
 */
var buildFieldList = function (dataSchema, fieldsProperties, fieldsConditions, values) {
    var fieldNameList = Object.keys(fieldsProperties);
    return fieldNameList.map(function (fieldName) {
        return buildFieldProps(fieldName, fieldsProperties[fieldName], dataSchema.properties[fieldName], dataSchema.required.includes(fieldName), fieldsConditions && fieldsConditions[fieldName], values ? values[fieldName] : undefined);
    });
};
export var getLinkedFieldList = function (groupConditions) {
    var fieldNameList = Object.keys(groupConditions);
    return fieldNameList
        .map(function (name) {
        var _a, _b;
        var dependencies = [];
        if (groupConditions[name] && groupConditions[name].visibility) {
            if (groupConditions[name].visibility.requiredFields) {
                dependencies = __spreadArrays(dependencies, groupConditions[name].visibility.requiredFields);
            }
            if (groupConditions[name].visibility.requiredFieldsValues) {
                var field = groupConditions[name]
                    .visibility.requiredFieldsValues.map(function (values) { return Object.keys(values); })
                    .reduce(function (prev, current) { return __spreadArrays(prev, current); }, []);
                return _a = {}, _a[name] = __spreadArrays(dependencies, Array.from(new Set(field))), _a;
            }
        }
        return _b = {}, _b[name] = dependencies, _b;
    })
        .reduce(function (prev, curr) {
        return __assign(__assign({}, prev), curr);
    }, {});
};
/**
 * Build field props
 * @param fieldName
 * @param iuiBehavior
 * @param properties
 * @param isRequired
 * @param fieldConditions
 * @param initialValue
 */
var buildFieldProps = function (fieldName, iuiBehavior, properties, isRequired, fieldConditions, initialValue) {
    var emptyValue = iuiBehavior['ui:emptyValue'];
    var display = iuiBehavior['ui:display'];
    var asyncOptions = properties.asyncItems && window[properties.asyncItems] ? window[properties.asyncItems] : undefined;
    var title = iuiBehavior['ui:title'];
    var options = properties.items ? buildItems(properties.items, iuiBehavior) : undefined;
    var fieldType = getFieldType(properties.type, properties.items, display, asyncOptions);
    var getFieldVisibility;
    var getFieldOptionsFiltered;
    if (fieldConditions) {
        if (fieldConditions.visibility) {
            getFieldVisibility = getFieldVisibilityMethod(fieldConditions.visibility);
        }
        if (fieldConditions.filters) {
            getFieldOptionsFiltered = getFieldFilterMethod(fieldConditions.filters, options);
        }
    }
    return {
        // @ts-ignore
        asyncOptions: asyncOptions,
        defaultValue: emptyValue,
        fieldType: fieldType,
        getFieldOptionsFiltered: getFieldOptionsFiltered,
        getFieldVisibility: getFieldVisibility,
        id: fieldName,
        initialValue: initialValue,
        label: title || properties.title,
        name: fieldName,
        options: options,
        required: isRequired,
    };
};
/**
 *  Get field type
 * @param type
 * @param items
 * @param forcedFieldType
 * @param asyncOptions
 */
var getFieldType = function (type, items, forcedFieldType, asyncOptions) {
    if (items) {
        if (forcedFieldType) {
            return forcedFieldType;
        }
        if (type === ISchemaType.Array) {
            return 'checkbox';
        }
        if (asyncOptions) {
            return 'select-autocomplete';
        }
        return 'select';
    }
    if (asyncOptions) {
        return 'text-autocomplete';
    }
    switch (type) {
        case ISchemaType.Boolean:
        case ISchemaType.String:
            return 'text';
        case ISchemaType.Number:
            return 'number';
        case ISchemaType.Date:
            return 'date';
        default:
            return 'text';
    }
};
/**
 *  Get field visibility check method
 * @param requiredFields
 * @param requiredFieldsValues
 */
var getFieldVisibilityMethod = function (_a) {
    var requiredFields = _a.requiredFields, requiredFieldsValues = _a.requiredFieldsValues;
    return function (formData) {
        var isVisible = true;
        if (requiredFields && requiredFields.length) {
            var requiredFieldsComplete = getRequiredFieldsComplete(requiredFields, formData);
            isVisible = requiredFieldsComplete.length === requiredFields.length;
        }
        if (requiredFieldsValues) {
            var requiredFieldsValuesEquals = getRequiredFieldsValuesEquals(requiredFieldsValues, formData);
            if (isVisible) {
                isVisible = !!requiredFieldsValuesEquals.find(function (value) { return value; });
            }
        }
        return isVisible;
    };
};
/**
 * Get field filter method
 * @param filters
 * @param currentOptionList
 */
var getFieldFilterMethod = function (filters, currentOptionList) {
    return function (formData) {
        var dataList = currentOptionList ? __spreadArrays(currentOptionList) : [];
        var activatedRequiredFilter = getActivatedRequiredFilter(filters, formData);
        var activatedRequiredValuesFilter = getActivatedRequiredValuesFilter(filters, formData);
        var conditionResolved = true;
        if (checkHaveRequiredFilter(filters)) {
            conditionResolved = !!activatedRequiredFilter;
        }
        if (checkHaveRequiredValuesFilter(filters)) {
            conditionResolved = !!activatedRequiredValuesFilter;
        }
        if (conditionResolved) {
            var filter = activatedRequiredValuesFilter
                ? activatedRequiredValuesFilter
                : activatedRequiredFilter
                    ? activatedRequiredFilter
                    : undefined;
            if (filter) {
                return filter.index.map(function (index) { return dataList[index]; });
            }
            return dataList;
        }
        return [];
    };
};
/**
 * Get required fields value check
 * @param requiredFieldsValues
 * @param formData
 */
var getRequiredFieldsValuesEquals = function (requiredFieldsValues, formData) {
    return requiredFieldsValues.map(function (data) {
        var keys = Object.keys(data);
        return keys
            .map(function (key) {
            if (Array.isArray(data[key])) {
                return data[key].sort() === formData[key].sort();
            }
            return data[key] === formData[key];
        })
            .reduce(function (acc, cur) {
            if (acc === false) {
                return false;
            }
            return cur;
        }, undefined);
    });
};
/**
 * Ger required field complete
 * @param requiredFields
 * @param formData
 */
var getRequiredFieldsComplete = function (requiredFields, formData) {
    return requiredFields.filter(function (fieldName) { return formData[fieldName]; });
};
/**
 * Get field filter required
 * @param filters
 * @param formData
 */
var getActivatedRequiredFilter = function (filters, formData) {
    return filters.find(function (filter) {
        if (filter.requiredFields && filter.requiredFields.length) {
            var requiredFieldsComplete = getRequiredFieldsComplete(filter.requiredFields, formData);
            return requiredFieldsComplete.length === filter.requiredFields.length;
        }
        return false;
    });
};
/**
 * Get field filter with required values
 * @param filters
 * @param formData
 */
var getActivatedRequiredValuesFilter = function (filters, formData) {
    return filters.find(function (filter) {
        if (filter.requiredFieldsValues) {
            var requiredFieldsValuesEquals = getRequiredFieldsValuesEquals(filter.requiredFieldsValues, formData);
            return requiredFieldsValuesEquals.includes(true);
        }
        return false;
    });
};
/**
 * Checl have required filter
 * @param filters
 */
var checkHaveRequiredFilter = function (filters) {
    return !!filters.find(function (filter) {
        return !!(filter.requiredFields && filter.requiredFields.length);
    });
};
/**
 * Check have required filter value
 * @param filters
 */
var checkHaveRequiredValuesFilter = function (filters) {
    return !!filters.find(function (filter) {
        return !!(filter.requiredFieldsValues && filter.requiredFieldsValues.length);
    });
};
/**
 * Overrides items values
 * @param items
 * @param uiBehavior
 */
var buildItems = function (items, uiBehavior) {
    return items.map(function (item, index) {
        return uiBehavior['ui:options'] && uiBehavior['ui:options'].listLabels && uiBehavior['ui:options'].listLabels[index]
            ? { label: uiBehavior['ui:options'].listLabels[index], value: item }
            : { label: item, value: item };
    });
};
/**
 * Get form initial values
 * @param properties
 */
export var getInitialValues = function (_a, formData) {
    var properties = _a.properties;
    var fieldNameList = Object.keys(properties);
    return fieldNameList.reduce(function (previous, current) {
        var _a, _b;
        var type = properties[current].type;
        if (!previous) {
            return _a = {},
                _a[current] = type === ISchemaType.Array
                    ? formData[current]
                        ? formData[current]
                        : []
                    : formData[current]
                        ? formData[current] : '',
                _a;
        }
        return __assign(__assign({}, previous), (_b = {}, _b[current] = type === ISchemaType.Array
            ? formData[current]
                ? formData[current]
                : []
            : formData[current]
                ? formData[current]
                : '', _b));
    }, {});
};
/**
 * Get field filtered options
 * @param field
 * @param values
 */
export var getFilteredOptions = function (field, values) {
    var _a, _b;
    if (field.options) {
        if (field.getFieldOptionsFiltered) {
            return _a = {}, _a[field.name] = field.getFieldOptionsFiltered(values), _a;
        }
        return _b = {}, _b[field.name] = field.options, _b;
    }
    return;
};
/**
 * Get filtered group field options
 * @param fieldList
 * @param values
 */
export var getGroupFilteredFieldOptions = function (fieldList, values) {
    return fieldList
        .map(function (field) {
        return getFilteredOptions(field, values);
    })
        .filter(function (optionsList) { return optionsList; })
        .reduce(function (previousFieldsOptions, currentFieldOptions) { return (__assign(__assign({}, previousFieldsOptions), currentFieldOptions)); }, {});
};
//# sourceMappingURL=form.core.js.map